<script setup lang="ts">
import { watch } from 'vue';

// PROPS
const props = defineProps<{
  modelValue: string;
  name: string;
  label: string;
  disabled?: boolean;
  options: any;
}>();

// EMIT
const emit = defineEmits<{
  (e: 'update:modelValue', newValue: string): void;
}>();

// WATCH
watch(
  () => props.modelValue,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      emit('update:modelValue', newValue);
    }
  },
);
</script>

<template>
  <q-select
    :label="props.label"
    :model-value="props.modelValue"
    :disable="props.disabled"
    v-bind="$attrs"
    :options="props.options"
    @update:model-value="emit('update:modelValue', $event)"
    class="standard-select"
  />
</template>

<style lang="scss">
.standard-select {
  padding-bottom: 20px;
}
</style>
